import { render, staticRenderFns } from "./FaqListAddNew.vue?vue&type=template&id=1061bcb2&"
import script from "./FaqListAddNew.vue?vue&type=script&lang=js&"
export * from "./FaqListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./FaqListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports